import { __awaiter } from "tslib";
import { default as request } from "@pb/utils/request";
import { getWhitelistingHeader } from "@pb/utils/request";
import { getWAFWhitelistingHeader } from "@pb/utils/request";
import { default as IS_CLIENT } from "@pb/utils/constants/isClient";
import { getLocale } from "@pb/utils/locale";
import { getTouchpoint } from "@pb/utils/touchpoint";
import { default as getCookie } from "@pb/utils/getCookie";
import { cookies } from "@pb/utils/constants/cookies";
import { default as consoleEvents } from "@pb/utils/consoleEvents";
const callE4Api = (productKey) => __awaiter(void 0, void 0, void 0, function* () {
    let recommendationsData = null;
    const params = new URLSearchParams();
    params.set('productKey', productKey);
    params.set('touchPoint', getTouchpoint());
    const endpoint = `https://api.hm.com/search-services/v1/${getLocale('mixed')}/recos/product-page?${params.toString()}`;
    const userCookie = JSON.parse(getCookie(cookies.USER_COOKIE_NAME) || '{}');
    const agCookie = getCookie('agCookie');
    try {
        const { data } = yield request.get(endpoint, {
            headers: Object.assign(Object.assign(Object.assign(Object.assign({}, getWhitelistingHeader()), getWAFWhitelistingHeader()), { 'X-Session-Key': (userCookie === null || userCookie === void 0 ? void 0 : userCookie.sessionKey) || agCookie, 'X-Customer-Key': (userCookie === null || userCookie === void 0 ? void 0 : userCookie.customerKey) || (userCookie === null || userCookie === void 0 ? void 0 : userCookie.sessionKey) || agCookie }), (!IS_CLIENT && { 'User-Agent': 'glo_sre_prd node' })),
            shouldRemoveData: true,
        });
        recommendationsData = data;
    }
    catch (e) {
        consoleEvents.log(`Error on calling Search Experience API: ${e} (${endpoint})`);
    }
    return recommendationsData;
});
export default callE4Api;
//# sourceMappingURL=callE4Api.js.map